import React from 'react';

// -- Component
import Auth from './auth/Auth';

const Container: React.FC = () => {
    return (
        <Auth />
    );
};

export default Container;